import React from "react";

export const About = (props) => {
  return (
    <div id="about">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-6">
            {" "}
            <img src="img/quincho-imagen.png" className="img-responsive" alt="" />{" "}
             {/* <img
              src="img/los-tres.png"
              className="img-responsive"
              alt="los tres"
            /> */}
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="about-text" style={{ fontSize: "18px", lineHeight: "1.6" }}>
              <h2>Información</h2>
              <p style={{ fontSize: "18px", lineHeight: "1.6" }}>{props.data ? props.data.paragraph : "loading..."}</p>
              <h3>Un espacio exclusivo, ideal para:</h3>
              <div className="list-style">
                <div className="col-lg-12 col-sm-12 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why.map((d, i) => (
                          <li key={`${d}-${i}`}>{d}</li>
                        ))
                      : "loading"}
                  </ul>
                </div>
                {/* <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why2.map((d, i) => (
                          <li key={`${d}-${i}`}> {d}</li>
                        ))
                      : "loading"}
                  </ul>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
